import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { partnerTokenExchangeSchema } from './PartnerTokenExchange.schema';
import PartnerTokenExchangeCredentials from './PartnerTokenExchangeCredentials';
import PartnerTokenExchangeForm from './PartnerTokenExchangeForm';
import usePartnerTokenExchangeSubmit from './usePartnerTokenExchangeSubmit';
import {
  PartnerTokenExchangeSubtitle,
  PartnerTokenExchangeTitle,
} from './PartnerTokenExchange.styles';
import FormWithProvider from '@/components/forms/form/Form';
import { ViewLayoutWrapper } from '@/pages/_layouts/publicLayout/layoutDesktop/LayoutDesktop.styles';

const PartnerTokenExchange = () => {
  const { t } = useTranslation();
  const {
    clearErrors,
    credentials,
    errorMessage,
    handleSubmitTokenExchange,
    isSubmitting,
  } = usePartnerTokenExchangeSubmit();

  return (
    <ViewLayoutWrapper>
      <Col sm={10} md={9} lg={8} xl={6}>
        {credentials ? (
          <PartnerTokenExchangeCredentials credentials={credentials} />
        ) : (
          <FormWithProvider
            horizontal
            onSubmit={handleSubmitTokenExchange}
            resolver={partnerTokenExchangeSchema()}
            defaultValues={{ token: '', redirectUri: '' }}
          >
            <PartnerTokenExchangeTitle data-testid="partner-token-exchange-title">
              {t('pagePartnerTokenExchange.title')}
            </PartnerTokenExchangeTitle>
            <PartnerTokenExchangeSubtitle data-testid="partner-token-exchange-subtitle">
              {t('pagePartnerTokenExchange.subtitle')}
            </PartnerTokenExchangeSubtitle>
            <PartnerTokenExchangeForm
              clearErrors={clearErrors}
              errorMessage={errorMessage}
              isSubmitting={isSubmitting}
            />
          </FormWithProvider>
        )}
      </Col>
    </ViewLayoutWrapper>
  );
};

export default PartnerTokenExchange;
